import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  Input,
  model,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { safeJsonParse } from '@utils/json';
import {
  createAjvValidator,
  createJSONEditor,
  JsonEditor,
} from 'vanilla-jsoneditor';

@Component({
  selector: 'app-json-editor',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './json-editor.component.html',
  styleUrl: './json-editor.component.scss',
})
export class JsonEditorComponent implements AfterViewInit {
  @ViewChild('editor') ref!: ElementRef<HTMLAudioElement>;

  @Input() schema?: any;

  value = model<Record<string, any>>({});
  private editor: JsonEditor;

  constructor() {
    effect(() => {
      this.editor.update({
        json: this.value(),
      });
    });
  }

  ngAfterViewInit(): void {
    this.editor = createJSONEditor({
      target: this.ref.nativeElement,
      props: {
        mode: 'text',
        content: {
          json: this.value(),
        },
        validator: this.schema
          ? createAjvValidator({
              schema: this.schema,
            })
          : undefined,
        onChange: ({ text }, _, { contentErrors }) => {
          if (contentErrors) {
            return;
          }
          this.value.set(safeJsonParse(text));
        },
        mainMenuBar: false,
        navigationBar: false,
        statusBar: false,
      },
    });
  }
}
